import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ScheduleService } from 'src/app/core';
import { EScheduleStatus, ScheduleModel } from 'src/app/shared';
import * as domToImg from 'dom-to-image';
import {saveAs} from 'file-saver'
import { AttachmentType, ScheduleFilesAttachment } from 'src/app/shared/models/schedule.model';
import { AttachmentTypeService } from 'src/app/core/services/attachment-type.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedule-detail-tab',
  templateUrl: './schedule-detail-tab.component.html',
  styleUrls: ['./schedule-detail-tab.component.scss']
})
export class ScheduleDetailTabComponent implements OnInit {

  @Input() scheduleDetail: ScheduleModel;
  @Input() scheduleHistory: any[] = [];
  @Input() scheduleFilesAttachment: any[] =[];  

  scheduleTitle = '';
  qrString = new String();
  src = '';

  attachmentTypeList: AttachmentType[] = [];
  attachmentMaster: any[] = [];
  isOnlyGeneralType = false;

  subscriptions: Subscription[] = [];

  constructor(public activeModal: NgbActiveModal,  private router: Router, private attachmentTypeService: AttachmentTypeService, private scheduleService: ScheduleService) { }
  get scheduleStatus(): typeof EScheduleStatus {
    return EScheduleStatus;
  }
  ngOnInit(): void {
    this.scheduleTitle = this.scheduleDetail.scheduleTitle;

    this.loadAttachmentTypeData();
    this.getQRCode();
  }

  getDownloadPath(viewPath: string){
    if(viewPath.includes('https://view.officeapps.live.com/op/embed.aspx?src=')) viewPath = viewPath.replace('https://view.officeapps.live.com/op/embed.aspx?src=', '');
    return viewPath;
  }

  loadAttachmentTypeData(): void{
    const typeSub = this.attachmentTypeService.getAllActive().subscribe(res =>{
      if(res.isSuccess){
        this.attachmentTypeList = res.result;
        this.attachmentTypeList = this.attachmentTypeList.sort(this.compare_type);
        this.attachmentListSeperator();
        if(this.scheduleFilesAttachment.filter(x => x.attachmentTypeId == 0 
          || x.attachmentTypeId == null 
          || x.attachmentTypeId == undefined).length == this.scheduleFilesAttachment.length){
          this.isOnlyGeneralType = true;
        }
        console.log(this.attachmentMaster);
      }
    });    
    this.subscriptions.push(typeSub);
  }
  attachmentListSeperator(): void{    
    var emptyList: ScheduleFilesAttachment[] = [];
    this.attachmentTypeList.forEach(e =>{
      this.attachmentMaster.push({
        title: e.title,
        typeId: e.id,
        data: emptyList
      })
    });
    this.attachmentMaster.push({
      title: 'Tài liệu họp',
      typeId: 0,
      data: this.scheduleFilesAttachment.filter(x => x.attachmentTypeId == 0 || x.attachmentTypeId == null || x.attachmentTypeId == undefined)
    });
    this.attachmentMaster.forEach(e =>{
      if(e.typeId != 0){        
        e.data = this.scheduleFilesAttachment.filter(x => x.attachmentTypeId == e.typeId);
      }
      e.data = e.data.sort(this.compare);
    });    
  }

 compare(a: ScheduleFilesAttachment,b: ScheduleFilesAttachment) {
    if(a.sortOrder > b.sortOrder) return 1;
    else if(a.sortOrder < b.sortOrder) return -1;
    else return 0;
  }

  compare_type(a: AttachmentType, b: AttachmentType){
    if(a.sortOrder > b.sortOrder) return 1;
    else if(a.sortOrder < b.sortOrder) return -1;
    else return 0;
  }

  transformData(){
    
  }

  getQRCode(): void{
    const qrSub = this.scheduleService.getQRCodeByScheduleId(this.scheduleDetail.scheduleId).subscribe(res => {
      if(res.isSuccess){
        this.qrString = res.result as String;
        this.src = 'data:image/png;base64,' +  this.qrString
      } 
      else{
        console.debug('Error when retrieving QRCode');
      }
    });
    this.subscriptions.push(qrSub);
  }

  downloadQRDOM(){
    var node = document.getElementById('dom-qr-image');
    domToImg.toBlob(node).then(blob => {
      saveAs(blob, this.scheduleTitle + '.png');
    })    
  }
 

  closeTab(): void {
    this.router.navigateByUrl('/');
  }
  showFileContent(fileUrl: string){
    if(fileUrl.endsWith(".pdf")){
      window.open(fileUrl, "_blank")
    }
    var z = 'https://docs.google.com/gview?url=';
    fileUrl = fileUrl.replace(z, '');
    var host = window.location.origin + '/file'
    var goToPath = host + '?url=' + fileUrl; 
    // console.log(goToPath);
    //this.router.navigateByUrl(goToPath);
    window.open(goToPath, '_blank');
  }
  mapScheduleStatus(value): string {
    if (value === EScheduleStatus.Pending) {
      return 'Đang soạn thảo';
    } else if (value === EScheduleStatus.Approve) {
      return 'Đã duyệt';
    } else if (value === EScheduleStatus.Pause) {
      return 'Lịch bị hoãn';
    } else if (value === EScheduleStatus.Changed) {
      return 'Lịch bị dời';
    } else if (value === EScheduleStatus.Release) {
      return 'Đã phát hành';
    }
  }

}
